<template>
    <k-select
        ref="foodSelect"
        :label="trans('general.component.food_select.label')"
        :placeholder="trans('general.component.food_select.label')"
        v-model="selectedFoods"
        :options="foodOptions"
        :multiple="true"
        :show-selected-options="true"
        :allow-search="true"
        :show-tags="1"
        auto-close="false"
        :server-side-search="true"
        :error="error"
        v-on:search-enter="addNewOption"
        v-on:search="loadOptions"
        v-on:reset-error="$emit('reset-error')">
            <template #noResults="{ search }">
                <div v-if="search !== ''"
                     @click="addNewOption(search)"
                     role="button"
                     class="d-flex justify-content-between border-radius bg-gray-100 p-1 ps-3 align-items-center">
                    <label class="large">{{ search }}</label>
                    <span class="small btn btn-success btn-sm">
                        {{ trans('general.defaults.add')}}
                        <i class="fi fi-rr-arrow-turn-down-left"></i>
                    </span>
                </div>
                <div v-else>
                    {{ trans('general.defaults.no_results_found') }}
                </div>
            </template>
    </k-select>
</template>

<script>
import KSelect from "../molecules/KSelect.vue";

export default {
    name: "FoodSelect",
    components: {KSelect},
    props: {
        value: String|Array,
        error: String,
    },
    data() {
        return {
            selectedFoods: [],
            foodOptions: [],
        }
    },
    watch: {
        selectedFoods: {
            handler: function (val) {
                this.$emit('input', val.map(a => a.label).join('|'));
            },
            deep: true
        }
    },
    methods: {
        formatSelectedFoods() {
            if(this.value) {
                return this.value.split('|').map(a => {
                    return {label: a.label ? a.label : a, id: a.label ? a.label : a};
                });
            }

            return [];
        },
        loadOptions(search = '') {
            axios.get(`/settings/food?search=${search}&search_fields=label:like&limit=6`).then(response => {
                this.foodOptions = response.data.data.data.map(a => {
                    return {label: a.label, id: a.label};
                });
            });
        },
        addNewOption(option) {
            if(this.selectedFoods.find(a => a.label === option)) return;

            const newOption = {label: option, id: option};
            this.selectedFoods.push(newOption);
            this.$refs.foodSelect.setSearchQuery('');
        },
    },
    mounted() {
        this.selectedFoods = this.formatSelectedFoods();
        this.loadOptions();
    }
}
</script>
